import React, { useState } from "react"
import CustomButton from "../../components/custom-button/custom-button.component"
import QR from "../../assets/icons/qr-logo.svg"
import DownloadAppDialog from "../../components/download-app-dialog/download-app-dialog.component"

import * as S from "./download-app-banner.styles"
import FormPopup from "../../components/form-popup/form-popup.component"

const DownloadAppBanner = ({ title, description, leftButton, rightButton }) => {
  const [open, setOpen] = useState(false)
  const [openForm, setOpenForm] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleOpenForm = () => {
    setOpenForm(true)
  }
  const handleCloseForm = () => {
    setOpenForm(false)
  }
  const handleClose = () => {
    setOpen(false)
  }
  return (
    <S.Section>
      <S.Wrapper>
        <S.Title>{title}</S.Title>
        <S.Description>{description}</S.Description>
        <S.ButtonsContainer>
          <CustomButton onClick={handleClickOpen}>
            <QR />
            {leftButton?.title}
          </CustomButton>
          <CustomButton onClick={handleOpenForm} className="lightBorder">
            {rightButton?.title}
          </CustomButton>
        </S.ButtonsContainer>
      </S.Wrapper>
      <DownloadAppDialog open={open} handleClose={handleClose} />
      <FormPopup open={openForm} handleClose={handleCloseForm} />
    </S.Section>
  )
}

export default DownloadAppBanner
